<template>
  <div class="border py-2 mb-3">
    <div>
      <div class="form-check mb-3">
        <input
          class="form-check-input"
          type="checkbox"
          value="1"
          :id="`order-bump-${bump.id}`"
          v-model="selected"
        />
        <label
          class="form-check-label small fw-bold"
          :for="`order-bump-${bump.id}`"
        >
          {{ bump.checkbox_text || 'Add to your order' | translate }}
        </label>
      </div>
    </div>
    <div class="d-flex">
      <div>
        <img
          :src="imageUrl(bump.course.cover_photo)"
          alt=""
          class="img-fluid"
          style="max-width: 80px"
        />
      </div>
      <div class="mx-2 d-flex w-100">
        <div
          class="small"
          v-html="markdown(bump.headline || bump.course.title)"
        ></div>
        <div class="ms-auto text-nowrap">
          <div class="text-secondary" v-if="bump.show_original_price">
            <small>
              <del>{{ bump.course.price | price(page.currency) }}</del>
            </small>
          </div>
          <div>
            <small>{{ bump.price | price(page.currency) }}</small>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import snarkdown from 'snarkdown'

export default {
  props: ['bump'],
  filters: {
    price(value, currency) {
      return (value / 100).toLocaleString(document.documentElement.lang, {
        style: 'currency',
        currency,
        minimumFractionDigits: 0,
      })
    },
  },
  computed: {
    selected: {
      get() {
        return this.$store.state.selectedOrderBumps.find(
          (ob) => ob.id === this.bump.id,
        )
          ? true
          : false
      },
      set(value) {
        this.$store.commit('toggleOrderBump', this.bump)
      },
    },
    page() {
      return this.$store.state.page
    },
  },
  methods: {
    markdown(text) {
      if (text) {
        return snarkdown(text)
      }
      return ''
    },

    imageUrl(url) {
      if (url) {
        return `https://djceg34j53tq.cloudfront.net/${url}`
      }
      return 'https://placehold.co/1280x800/E1D4F1/ffffff'
    },
  },
}
</script>

<style></style>
